import { Channel } from '@/libraries/channel.ts';
import { extendOptions, copyToClipboard, processDataForCopyPaste } from '@/utils/general';

const channel = Channel.getInstance('ally');

export default {
	async goTo({}, url: string): Promise<any> {
		const response = await channel.emit({
			command: 'goTo',
			to: 'background',
			args: [ url ],
		});
	},
	async handleCopyPaste({}, data: any): Promise<any> {
		const cpData = processDataForCopyPaste(data);
		copyToClipboard(cpData);
	},
};
